import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', index, istemplate }) {
  var finalAlpha = sprite.alpha;
  sprite.alpha = 0;
  let delay = 0;
  if (istemplate && index) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    alpha: finalAlpha,
    duration: duration * speed,
    ease: 'power3.out',
    paused: true,
    delay: delay,
  });
  return animation;
}
export default { Animate };
